import React, { PureComponent, ReactComponentElement } from 'react';
import { ReactComponent as PigBankIcon } from 'src/bw/goal/piggy-bank.svg';
import CardService from '../../../services/card.service';
import Typography from '../../../components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';

export default class LinkedGoal extends PureComponent<any> {
    public override render(): ReactComponentElement<any> {
        const linkedGoal: JSX.Element = CardService.hasSavingsGoal(this.props) ? (
            <div className="savings-callout after24" key="savings-callout">
                <PigBankIcon className="pig" key="pig" />
                <Typography variant={TypographyVariants.HEADING_XS} className="title" key="title">
                    You are saving for this life event.
                </Typography>
                <Typography
                    variant={TypographyVariants.SUBTEXT}
                    className="link"
                    key="text"
                    onClick={() => this.props.handleOpenLinkedCard(this.props.drawerProps.card)}
                >
                    View the linked savings goal.
                </Typography>
            </div>
        ) : null;

        return linkedGoal;
    }
}
